import type React from 'react';

import type { SvgPathProps } from '../Icon';

import { getIcon } from '../Icon';

const StarFill: React.FC<SvgPathProps> = ({ size, isHovered }: SvgPathProps): React.ReactElement => {
  const normal = (
    <path d="M23.092 7.124a1 1 0 0 1 1.816 0l4.664 10.112a1 1 0 0 0 .79.574l11.059 1.311a1 1 0 0 1 .561 1.728l-8.176 7.56a1 1 0 0 0-.301.93l2.17 10.922a1 1 0 0 1-1.47 1.067l-9.717-5.44a1 1 0 0 0-.976 0l-9.718 5.44a1 1 0 0 1-1.469-1.068l2.17-10.922a1 1 0 0 0-.301-.929l-8.176-7.56a1 1 0 0 1 .561-1.728l11.058-1.31a1 1 0 0 0 .79-.575l4.665-10.112Z" />
  );

  const normalHover = (
    <path d="M18.755 7.934a1 1 0 0 1 1.754-.47l7.122 8.56a1 1 0 0 0 .913.35l11.02-1.596a1 1 0 0 1 .99 1.524l-5.94 9.419a1 1 0 0 0-.052.975l4.923 9.988a1 1 0 0 1-1.143 1.412L27.55 35.357a1 1 0 0 0-.944.253l-7.978 7.769a1 1 0 0 1-1.695-.651L16.2 31.616a1 1 0 0 0-.532-.82L5.815 25.61a1 1 0 0 1 .095-1.814l10.342-4.128a1 1 0 0 0 .615-.76l1.888-10.974Z" />
  );

  const xSmall = (
    <path d="M24 6.645c.452 0 .866.258 1.066.663l4.976 10.083 11.13 1.614a1.19 1.19 0 0 1 .658 2.028l-8.065 7.849 1.902 11.085a1.189 1.189 0 0 1-1.726 1.252l-9.93-5.233-9.952 5.234a1.19 1.19 0 0 1-1.726-1.253l1.902-11.085-8.064-7.85a1.189 1.189 0 0 1 .66-2.027l11.126-1.614 4.977-10.083A1.19 1.19 0 0 1 24 6.645Z" />
  );

  const xSmallHover = (
    <path d="M21.65 5.997a1.19 1.19 0 0 1 1.164.468l6.652 9.066 11.24-.343a1.189 1.189 0 0 1 1 1.882l-6.579 9.13 3.798 10.586a1.19 1.19 0 0 1-1.481 1.533l-10.69-3.429-8.89 6.883a1.19 1.19 0 0 1-1.917-.935l-.052-11.246-9.305-6.33a1.19 1.19 0 0 1-.51-1.148 1.19 1.19 0 0 1 .807-.963l10.677-3.52 3.151-10.796a1.19 1.19 0 0 1 .934-.838Z" />
  );

  return getIcon({ size, isHovered, normal, normalHover, xSmall, xSmallHover });
};

export default StarFill;
